import {useFormContext} from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@common-web/components/ui/form';
import {DatePicker} from '@common-web/components/ui/date-picker';

function mmddyyyyToIso(value: string | undefined): string {
  if (!value) return '';
  const parts = value.split('/');
  if (parts.length !== 3) return '';
  const [mm, dd, yyyy] = parts;
  if (!mm || !dd || !yyyy) return '';
  const monthStr = mm.padStart(2, '0');
  const dayStr = dd.padStart(2, '0');
  return `${yyyy}-${monthStr}-${dayStr}`;
}

function isoToMmddyyyy(value: string | undefined): string {
  if (!value) return '';
  const parts = value.split('-');
  if (parts.length !== 3) return '';
  const [yyyy, mm, dd] = parts;
  const monthStr = mm.padStart(2, '0');
  const dayStr = dd.padStart(2, '0');
  return `${monthStr}/${dayStr}/${yyyy}`;
}

export function DateField({
  name,
  label,
  placeholder,
}: {
  name: string;
  label: string;
  placeholder?: string;
}) {
  const {control} = useFormContext();
  return (
    <FormField
      control={control}
      name={name as any}
      render={({field}) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <DatePicker
              value={mmddyyyyToIso(field.value)}
              onChange={(iso) => field.onChange(isoToMmddyyyy(iso))}
              placeholder={placeholder || 'MM/DD/YYYY'}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
